"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.leadingWindow = leadingWindow;
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _iterable = require("../../internal/iterable");

var _circularBuffer = require("../../internal/circular-buffer");

var _concat = require("../$concat/concat");

var _repeatTimes = require("../repeat-times/repeat-times");

var _marked = _regenerator["default"].mark(leadingWindow);

function leadingWindow(source, size) {
  var _ref,
      filler,
      buffer,
      bufferReadProxy,
      index,
      _iteratorNormalCompletion,
      _didIteratorError,
      _iteratorError,
      _iterator,
      _step,
      item,
      _args = arguments;

  return _regenerator["default"].wrap(function leadingWindow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, filler = _ref.filler;
          buffer = new _circularBuffer.CircularBuffer(size);
          bufferReadProxy = new _circularBuffer.ReadOnlyCircularBuffer(buffer);
          buffer.fill(filler);
          index = 0;
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 8;
          _iterator = (0, _getIterator2["default"])((0, _concat.concat)(source, (0, _repeatTimes.repeatTimes)(size - 1, filler)));

        case 10:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 20;
            break;
          }

          item = _step.value;
          buffer.push(item);

          if (!(index + 1 >= size)) {
            _context.next = 16;
            break;
          }

          _context.next = 16;
          return bufferReadProxy;

        case 16:
          index++;

        case 17:
          _iteratorNormalCompletion = true;
          _context.next = 10;
          break;

        case 20:
          _context.next = 26;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](8);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 26:
          _context.prev = 26;
          _context.prev = 27;

          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }

        case 29:
          _context.prev = 29;

          if (!_didIteratorError) {
            _context.next = 32;
            break;
          }

          throw _iteratorError;

        case 32:
          return _context.finish(29);

        case 33:
          return _context.finish(26);

        case 34:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[8, 22, 26, 34], [27,, 29, 33]]);
}

var _default = (0, _iterable.iterableCurry)(leadingWindow, {
  minArgs: 1,
  maxArgs: 2,
  optionalArgsAtEnd: true,
  validateArgs: function validateArgs(args) {
    if (args[0] && (0, _typeof2["default"])(args[0]) === 'object') {
      var _args$ = args[0],
          filler = _args$.filler,
          size = _args$.size;

      if (size !== undefined && args[1] !== undefined) {
        throw new Error('size cannot be specified as both a positional and named argument to leadingWindow');
      }

      args[0] = size;
      args[1] = {
        filler: filler
      };
    }
  }
});

exports["default"] = _default;